import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { Link } from 'react-router-dom';

export default function BlogYoybuyGuide() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      {/* Article Header */}
      <section className="relative w-full pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Link
              to="/"
              className="text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Главная
            </Link>
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
            <span className="text-sm text-foreground-500">Блог</span>
          </div>
          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
            YOYBUY Spreadsheet 2026: Полный гид по покупкам из Китая через таблицы
          </h1>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Всё, что нужно знать о системе YOYBUY Spreadsheet — от регистрации до первой покупки.
            Сравнение комиссий, советы по доставке и экономии.
          </p>
          <div className="flex items-center justify-center gap-3 mt-5 text-xs text-foreground-500">
            <span>Обновлено: Июль 2026</span>
            <span>·</span>
            <span>Время чтения: 8 минут</span>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="w-full max-w-4xl mx-auto px-4 md:px-6 -mt-6">
        <div className="rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20a%20spreadsheet%20interface%20on%20screen%2C%20surrounded%20by%20fashion%20items%20neatly%20arranged%20on%20a%20minimalist%20desk%2C%20warm%20natural%20lighting%20from%20large%20window%2C%20Scandinavian%20interior%20design%2C%20cream%20and%20beige%20tones%2C%20clean%20and%20organized%20aesthetic%2C%20editorial%20photography%20style%2C%20soft%20shadows%2C%20professional%20yet%20cozy%20atmosphere&width=1200&height=600&seq=blog-featured-yoybuy-01&orientation=landscape"
            alt="YOYBUY Spreadsheet полный гид"
            title="YOYBUY Spreadsheet гид по покупкам из Китая"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>
      </section>

      {/* Article Body */}
      <article className="w-full max-w-3xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="prose-custom text-foreground-700 leading-relaxed space-y-8">
          {/* Intro */}
          <p className="text-lg text-foreground-800 leading-relaxed">
            В 2026 году покупки из Китая стали ещё доступнее благодаря инновационным
            платформам, таким как <strong>YOYBUY Spreadsheet</strong>. Если вы ищете
            способ заказывать товары с Taobao и 1688 без скрытых комиссий и с полным
            контролем расходов — эта статья для вас. Мы собрали всю ключевую информацию
            о системе <strong>YOYBUY spreadsheet</strong> и платформе{' '}
            <strong>Kaspreadsheet</strong> в одном месте.
          </p>

          {/* H2: What is YOYBUY Spreadsheet */}
          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Что такое YOYBUY Spreadsheet и как это работает?
            </h2>
            <p className="mb-4">
              <strong>YOYBUY Spreadsheet</strong> — это не просто таблица, а целая
              экосистема для заказа товаров из Китая. В отличие от обычных
              посредников, которые скрывают реальные цены за многослойными комиссиями,
              система <strong>YOYBUY spreadsheet</strong> показывает вам полную
              структуру расходов в реальном времени.
            </p>
            <p className="mb-4">
              Когда вы заходите на платформу <strong>Kaspreadsheet</strong>, вы видите
              структурированную таблицу, где каждая строка — это отдельный товар, а
              столбцы содержат:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Название товара и ссылку на источник (Taobao, 1688 и другие)</li>
              <li>Цену товара в юанях и в вашей валюте</li>
              <li>Комиссию агента (обычно 5-10%)</li>
              <li>Стоимость международной доставки с разными вариантами</li>
              <li>Итоговую цену с учётом всех сборов</li>
            </ul>
            <p>
              Такой подход делает <strong>YOYBUY spreadsheet</strong> идеальным
              инструментом для тех, кто ценит прозрачность и хочет контролировать
              каждый этап закупки.
            </p>
          </section>

          {/* H2: Advantages */}
          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Почему YOYBUY Spreadsheet выгоднее традиционных агентов?
            </h2>
            <p className="mb-4">
              Главное преимущество <strong>YOYBUY Spreadsheet</strong> — это
              экономия. По нашим подсчётам, пользователи системы экономят в среднем
              25-40% по сравнению с заказом через традиционных посредников. Вот
              почему:
            </p>

            <div className="bg-background-100 rounded-xl p-6 mb-4 border border-secondary-200/50">
              <h3 className="font-semibold text-foreground-900 mb-3">
                Сравнение расходов: традиционный агент vs YOYBUY Spreadsheet
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-secondary-200">
                      <th className="text-left py-2 pr-4 font-semibold text-foreground-800">Статья расходов</th>
                      <th className="text-left py-2 pr-4 text-foreground-600">Обычный агент</th>
                      <th className="text-left py-2 text-primary-600">YOYBUY Spreadsheet</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-secondary-100">
                      <td className="py-2 pr-4">Цена товара</td>
                      <td className="py-2 pr-4">100%</td>
                      <td className="py-2 text-primary-600">100%</td>
                    </tr>
                    <tr className="border-b border-secondary-100">
                      <td className="py-2 pr-4">Комиссия агента</td>
                      <td className="py-2 pr-4">15-20%</td>
                      <td className="py-2 text-primary-600">5-10%</td>
                    </tr>
                    <tr className="border-b border-secondary-100">
                      <td className="py-2 pr-4">Доставка</td>
                      <td className="py-2 pr-4">Завышенный тариф</td>
                      <td className="py-2 text-primary-600">Рыночный тариф</td>
                    </tr>
                    <tr className="border-b border-secondary-100">
                      <td className="py-2 pr-4">Скрытые сборы</td>
                      <td className="py-2 pr-4">Часто присутствуют</td>
                      <td className="py-2 text-primary-600">Отсутствуют</td>
                    </tr>
                    <tr>
                      <td className="py-2 pr-4 font-semibold">Итого переплата</td>
                      <td className="py-2 pr-4 text-red-500">30-50%</td>
                      <td className="py-2 text-primary-600 font-semibold">5-15%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          {/* H2: How to Start */}
          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Как начать использовать YOYBUY Spreadsheet: пошаговая инструкция
            </h2>

            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-primary-600 font-bold text-sm">1</span>
                </div>
                <div>
                  <h3 className="font-semibold text-foreground-900 mb-1">
                    Перейдите на платформу Kaspreadsheet
                  </h3>
                  <p className="text-sm text-foreground-600">
                    Откройте{' '}
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-primary-600 hover:text-primary-700 underline cursor-pointer"
                    >
                      официальный сайт Kaspreadsheet
                    </a>{' '}
                    и ознакомьтесь с интерфейсом. Платформа доступна без регистрации
                    для просмотра каталога.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-primary-600 font-bold text-sm">2</span>
                </div>
                <div>
                  <h3 className="font-semibold text-foreground-900 mb-1">
                    Выберите категорию товаров
                  </h3>
                  <p className="text-sm text-foreground-600">
                    На платформе <strong>Kaspreadsheet</strong> доступно 14 категорий:
                    от обуви и одежды до аксессуаров и парфюмерии. Выберите нужную
                    категорию и просмотрите доступные товары в таблице{' '}
                    <strong>YOYBUY spreadsheet</strong>.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-primary-600 font-bold text-sm">3</span>
                </div>
                <div>
                  <h3 className="font-semibold text-foreground-900 mb-1">
                    Добавьте товары в таблицу
                  </h3>
                  <p className="text-sm text-foreground-600">
                    Скопируйте ссылку на товар с Taobao или 1688 и вставьте её в
                    таблицу <strong>YOYBUY spreadsheet</strong>. Система
                    автоматически рассчитает все расходы.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-primary-600 font-bold text-sm">4</span>
                </div>
                <div>
                  <h3 className="font-semibold text-foreground-900 mb-1">
                    Оформите заказ
                  </h3>
                  <p className="text-sm text-foreground-600">
                    После проверки всех позиций в таблице{' '}
                    <strong>YOYBUY spreadsheet</strong> подтвердите заказ. Вы
                    получите отслеживание на каждом этапе — от склада в Китае до
                    вашей двери.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* H2: Categories Overview */}
          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Какие категории товаров доступны в YOYBUY Spreadsheet?
            </h2>
            <p className="mb-4">
              Система <strong>YOYBUY spreadsheet</strong> охватывает 14
              категорий товаров, каждая из которых имеет свою страницу с актуальными
              ценами. Вот полный список доступных категорий:
            </p>
            <div className="grid grid-cols-2 gap-2">
              {[
                'Обувь', 'Худи и свитера', 'Футболки', 'Куртки',
                'Брюки и шорты', 'Головные уборы', 'Комплекты', 'Нижнее бельё',
                'Джерси', 'Аксессуары', 'Сумки', 'Ремни',
                'Парфюмерия', 'Прочие товары',
              ].map((cat, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-check-line w-4 h-4 flex items-center justify-center text-primary-500 flex-shrink-0"></i>
                  <span>{cat}</span>
                </div>
              ))}
            </div>
            <p className="mt-4">
              Каждая категория регулярно обновляется. Вы всегда видите актуальные
              цены и наличие товаров в <strong>YOYBUY spreadsheet</strong>.
            </p>
          </section>

          {/* H2: Tips */}
          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Советы по экономии с YOYBUY Spreadsheet
            </h2>
            <div className="space-y-4">
              <div className="p-5 rounded-xl bg-accent-50 border border-accent-200/50">
                <h3 className="font-semibold text-foreground-900 mb-1">
                  <i className="ri-lightbulb-line w-5 h-5 flex items-center justify-center text-accent-500 inline mr-2"></i>
                  Объединяйте заказы
                </h3>
                <p className="text-sm text-foreground-600">
                  Чем больше товаров в одной таблице{' '}
                  <strong>YOYBUY spreadsheet</strong>, тем ниже стоимость доставки
                  за единицу. Рекомендуем собирать заказы и отправлять одной
                  посылкой.
                </p>
              </div>
              <div className="p-5 rounded-xl bg-accent-50 border border-accent-200/50">
                <h3 className="font-semibold text-foreground-900 mb-1">
                  <i className="ri-lightbulb-line w-5 h-5 flex items-center justify-center text-accent-500 inline mr-2"></i>
                  Сравнивайте варианты доставки
                </h3>
                <p className="text-sm text-foreground-600">
                  В <strong>YOYBUY spreadsheet</strong> отображается несколько
                  вариантов доставки с разными сроками и ценами. Выбирайте
                  оптимальный для вашего бюджета.
                </p>
              </div>
              <div className="p-5 rounded-xl bg-accent-50 border border-accent-200/50">
                <h3 className="font-semibold text-foreground-900 mb-1">
                  <i className="ri-lightbulb-line w-5 h-5 flex items-center justify-center text-accent-500 inline mr-2"></i>
                  Следите за обновлениями
                </h3>
                <p className="text-sm text-foreground-600">
                  Цены на <strong>Kaspreadsheet</strong> обновляются регулярно.
                  Проверяйте таблицу <strong>YOYBUY spreadsheet</strong> перед
                  каждым заказом для получения лучших цен.
                </p>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="bg-primary-500 rounded-2xl p-8 md:p-10 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
              Готовы начать экономить с YOYBUY Spreadsheet?
            </h2>
            <p className="text-white/85 mb-6 max-w-lg mx-auto">
              Присоединяйтесь к тысячам покупателей, которые уже используют{' '}
              <strong>YOYBUY Spreadsheet</strong> для заказа товаров из Китая.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3 rounded-full bg-white text-primary-700 text-sm font-semibold hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Перейти к платформе
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <Link
                to="/"
                className="px-7 py-3 rounded-full border-2 border-white/70 text-white text-sm font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                На главную
                <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </section>

          {/* Back to Home */}
          <div className="text-center pt-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              Вернуться на главную страницу yoybuy.bond
            </Link>
          </div>
        </div>
      </article>

      {/* Schema.org FAQPage + BlogPosting */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Что такое YOYBUY Spreadsheet?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "YOYBUY Spreadsheet — это система заказов товаров из Китая через структурированную таблицу на платформе Kaspreadsheet, где отображаются цена товара, комиссия агента, стоимость доставки и итоговая цена."
                }
              },
              {
                "@type": "Question",
                "name": "Сколько можно сэкономить с YOYBUY Spreadsheet?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Пользователи YOYBUY Spreadsheet экономят от 25% до 40% по сравнению с традиционными посредниками благодаря прозрачным комиссиям и рыночным тарифам на доставку."
                }
              },
              {
                "@type": "Question",
                "name": "Какие категории товаров доступны в YOYBUY Spreadsheet?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Доступно 14 категорий: обувь, худи и свитера, футболки, куртки, брюки и шорты, головные уборы, комплекты, нижнее бельё, джерси, аксессуары, сумки, ремни, парфюмерия и прочие товары."
                }
              }
            ]
          })
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: (() => {
            const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoybuy.bond';
            const pagePath = '/blog/yoybuy-spreadsheet-guide';
            return JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BlogPosting",
              "headline": "YOYBUY Spreadsheet 2026: Полный гид по покупкам из Китая через таблицы",
              "description": "Всё, что нужно знать о системе YOYBUY Spreadsheet — от регистрации до первой покупки. Сравнение комиссий, советы по доставке и экономии.",
              "image": "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20a%20spreadsheet%20interface%20on%20screen%2C%20surrounded%20by%20fashion%20items%20neatly%20arranged%20on%20a%20minimalist%20desk%2C%20warm%20natural%20lighting%20from%20large%20window%2C%20Scandinavian%20interior%20design%2C%20cream%20and%20beige%20tones%2C%20clean%20and%20organized%20aesthetic%2C%20editorial%20photography%20style%2C%20soft%20shadows%2C%20professional%20yet%20cozy%20atmosphere&width=1200&height=600&seq=blog-featured-yoybuy-01&orientation=landscape",
              "datePublished": "2026-07-01",
              "dateModified": "2026-07-05",
              "author": {
                "@type": "Organization",
                "name": "yoybuy.bond",
                "url": siteUrl
              },
              "publisher": {
                "@type": "Organization",
                "name": "yoybuy.bond",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg"
                }
              },
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": siteUrl + pagePath
              },
              "url": siteUrl + pagePath,
              "inLanguage": "ru",
              "isAccessibleForFree": true
            });
          })()
        }}
      />

      <Footer />
    </div>
  );
}